export const ConnectionPrefix = {
  Game: 'game',
};

export const GameLiveConnectionMethod = {
  Ping: 'Ping',
  Spin: 'Spin',
  DemoSpin: 'DemoSpin',
  GameOpen: 'GameOpen',
  BalanceUpdate: 'BalanceUpdate',
  JackpotConnect: 'JackpotConnect',
  GetInitialState: 'GetInitialState',
  MaintenanceNotify: 'MaintenanceNotify',
  JackpotWinnerInfo: 'JackpotWinnerInfo',
  GetDemoInitialState: 'GetDemoInitialState',
  GetBalance: 'GetBalance',
  GetBalanceResult: 'GetBalanceResult',
  GetTournamentBalanceResult: 'GetTournamentBalanceResult',
  GetTournamentBalance: 'GetTournamentBalance',
  GetBoostedJackpotWin: 'GetBoostedJackpotWin',
  Error: 'error',
  Gamble: 'Gamble',
  DemoGamble: 'DemoGamble',
  SpinCollect: 'SpinCollect',
  DemoSpinCollect: 'DemoSpinCollect',
  GetTournamentInfo: 'GetTournamentInfo',
};

export const GameLiveConnectionEvent = {
  DemoInitialStateResult: 'DemoInitialStateResult',
  InitialStateResult: 'InitialStateResult',
  DemoSpinResult: 'DemoSpinResult',
  SpinResult: 'SpinResult',
  FreeBetAwarded: 'FreeBetAwarded',
  JackpotUpdate: 'JackpotUpdate',
  JackpotWin: 'JackpotWin',
  BoostedJackpotWinnerInfoResult: 'BoostedJackpotWinnerInfoResult',
  BoostedJackpotActivationInfoResult: 'BoostedJackpotActivationInfoResult',
  BoostedJackpotExpirationInfoResult: 'BoostedJackpotExpirationInfoResult',
  GetBoostedJackpotWinResult: 'BoostedJackpotWinResult',
  JackpotWinnerInfoResult: 'JackpotWinnerInfoResult',
  JackpotSceneResult: 'JackpotSceneResult',
  OpenJackpotSceneItem: 'OpenJackpotSceneItem',
  OpenJackpotScene: 'OpenJackpotScene',
  JackpotSceneItemResult: 'JackpotSceneItemResult',
  GambleResult: 'GambleResult',
  DemoGambleResult: 'DemoGambleResult',
  SpinCollectResult: 'SpinCollectResult',
  DemoSpinCollectResult: 'DemoSpinCollectResult',
  DemoSpinAvalancheResult: 'DemoSpinAvalancheResult',
  SpinAvalancheResult: 'SpinAvalancheResult',
  GetTournamentInfoResult: 'GetTournamentInfoResult',
};

export const CommonConnectionsMethod = {
  Reconnecting: 'Reconnect',
  Reconnected: 'Reconnected',
  ConnectionClose: 'ConnectionClose',
  UnderMaintenance: 'UnderMaintenance',
};
